import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnComponent } from './components/btn/btn.component';
import { TitleComponent } from './components/title/title.component';
import { InputComponent } from './components/input/input.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastComponent } from './components/toast/toast.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TableComponent } from './components/table/table.component';
import { SelectComponent } from './components/dropdowns/select/select.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { SelectOrganizationComponent } from './components/dropdowns/select-organization/select-organization.component';
import { SpinnerComponent } from './components/spinnner/spinner.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SelectRoleComponent } from './components/dropdowns/select-role/select-role.component';
import { SelectGradeComponent } from './components/dropdowns/select-grade/select-grade.component';
import { QuillModule } from 'ngx-quill'
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { SelectPageSizeComponent } from './components/dropdowns/select-page-size/select-page-size.component';
import { AddAriaLabelDirective } from './directives/add-aria-label.directive';
import { DateFormatPipe } from "../core/pipes/date-format.pipe";
import { SelectCountyComponent } from './components/dropdowns/select-county/select-county.component';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { SelectCourseComponent } from './components/dropdowns/select-course/select-course.component';
import { CardListComponent } from './components/cards/card-list/card-list.component';
import { LimitPipe } from './pipes/limit.pipe';
import { SelectSchoolComponent } from './components/dropdowns/select-school/select-school.component';
import { CollapseComponent } from './components/collapse/collapse.component';
import { SelectSchoolYearComponent } from './components/dropdowns/select-school-year/select-school-year.component';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { AccordionComponent } from './components/accordion/accordion.component';
import { StayTimerComponent } from './components/stay-timer/stay-timer.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';

@NgModule({
    declarations: [
        BtnComponent,
        TitleComponent,
        InputComponent,
        ToastComponent,
        TableComponent,
        SpinnerComponent,
        SelectComponent,
        SelectOrganizationComponent,
        SelectRoleComponent,
        SelectGradeComponent,
        SelectPageSizeComponent,
        AddAriaLabelDirective,
        SelectCountyComponent,
        SelectCourseComponent,
        CardListComponent,
        LimitPipe,
        SelectSchoolComponent,
        CollapseComponent,
        SelectSchoolYearComponent,
        ResetPasswordFormComponent,
        AccordionComponent,
        StayTimerComponent,
        AlertDialogComponent
    ],
    exports: [
        BtnComponent,
        TitleComponent,
        InputComponent,
        TableComponent,
        SelectComponent,
        SelectOrganizationComponent,
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        NzSelectModule,
        SpinnerComponent,
        SelectRoleComponent,
        SelectGradeComponent,
        NzCheckboxModule,
        AddAriaLabelDirective,
        SelectCountyComponent,
        NzCollapseModule,
        SelectCourseComponent,
        CardListComponent,
        CollapseComponent,
        LimitPipe,
        SelectSchoolComponent,
        SelectSchoolYearComponent,
        ResetPasswordFormComponent,
        AccordionComponent,
        StayTimerComponent,
        AlertDialogComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NzSelectModule,
        NzPaginationModule,
        NzTableModule,
        NzDropDownModule,
        NzSpinModule,
        QuillModule.forRoot(),
        NzBadgeModule,
        NzCheckboxModule,
        DateFormatPipe,
        NzCollapseModule,
        NzPopoverModule
    ]
})
export class SharedModule { }
